import React, { useCallback } from "react";
import { editParticipants } from "../messages";
import { ReactComponent as ArrowRight } from "assets/icons/arrow-right.svg";
import { useChallenge } from "contexts/Challenge/useChallenge";
import { useHistory } from "react-router-dom";

const EditParticipantsButton = () => {
  const { viewingChallenge } = useChallenge();

  const history = useHistory();

  const onClick = useCallback(() => {
    history.push(`/challenge/${viewingChallenge}/configs/participants/edit`);
  }, [history, viewingChallenge]);

  return (
    <div className="configurations__item" onClick={onClick}>
      <p>{editParticipants}</p>
      <ArrowRight />
    </div>
  );
};

export default EditParticipantsButton;
